/* eslint-disable @typescript-eslint/no-empty-function */
import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import './hubspotForm.scss';
import { textTitle2 } from '../../styles/typography';
import { classNames } from '../../utils/style';

import { moveRequiredAsterisk, useErrorObserver } from './logic';

declare global {
  interface Window {
    jQuery?: any;
    hbspt?: any;
  }
}
export interface HubspotFormProps {
  formId: string;
  portalId: string;
  title?: string;
  center?: boolean;
  scriptLoaded?: boolean;
}

export const HubspotForm = ({
  formId,
  portalId,
  title,
  center,
  scriptLoaded = false,
}: HubspotFormProps) => {
  const { disconnect, observe } = useErrorObserver();
  const [instanceId] = useState(() => uuidv4());

  useEffect(() => {
    // hubspot stupid hack
    if (scriptLoaded) {
      window.jQuery =
        window.jQuery ||
        (() => ({
          // these are all methods required by HubSpot
          change: () => {},
          trigger: () => {},
        }));

      window.hbspt.forms.create({
        formId: formId,
        formInstanceId: instanceId,
        onFormReady: () => {
          // remove hubspot styles that should not be there
          document
            .querySelectorAll("style[id^='hs-form']")
            .forEach((style) => style.remove());
          // move "*" in the checkbox label
          document
            .querySelectorAll('.hs-form-booleancheckbox')
            .forEach(moveRequiredAsterisk);

          const inputs = [
            ...Array.from(document.querySelectorAll('.hs-form .field input')),
            ...Array.from(document.querySelectorAll('.hs-form .field select')),
          ];

          if (center) {
            document.querySelector('.hs-form')?.classList.add('center');
            document.querySelector('.hs-submit')?.classList.add('center');
          }

          inputs.forEach(observe as any);
        },
        portalId,
        region: 'eu1',
        target: `#hubspot-${formId}`,
      });
    }

    return () => {
      disconnect();
    };
  }, [center, disconnect, formId, instanceId, observe, portalId, scriptLoaded]);

  return (
    <div className="website_hs_form">
      {title && <h2 className={classNames('pb-32', textTitle2)}>{title}</h2>}
      <div className="w-full" id={`hubspot-${formId}`} />
    </div>
  );
};
